<re-captcha
  [formControl]="captchaFormControlAsFormControl"
  [siteKey]="recaptchaKey"
  (resolved)="verifyRecaptchaCode($event)"
></re-captcha>
<span
  class="ntfc-has-error"
  *ngIf="
    captchaFormControl.invalid &&
    (captchaFormControl.dirty || captchaFormControl.touched) &&
    captchaFormControl.hasError('isRiskScoreInvalid')
  "
  >A hitelesítés nem sikerüt, kérjük próbálja meg újra!</span
>
